/**
 * GameCommunicator
 * Basic implementation of window.postmessage communication with
 Iframed PNG game.
 */
export default {
    source: undefined,
    targetOrigin: undefined,
    onGameExit: () => {},
    multiScreenMode: false,
    /**
     * Initiates the communication with the Iframe
     * @@param {iframe} element
     */
    init: function(element, launchUrl) {
        this.destroy()

        window.addEventListener('message', this.processGameMessage.bind(this))
        this.source = element.contentWindow
        this.targetOrigin = launchUrl // target origin url (the base used in the iframe src)
    },
    destroy: function() {
        console.log('GameCommunicator destroy')
        if (this.boundProcessGameMessage) {
            window.removeEventListener('message', this.boundProcessGameMessage)
            this.boundProcessGameMessage = null
        }
    },
    /**
     * Sends the message to the Iframe
     * @@param {object} data
     * Example of adding an Engage event listener:
     GameCommunicator.postMessage({ messageType: "addEventListener",
     eventType: "roundStarted" })
     * Example of calling Engage function: GameCommunicator.postMessage({
     messageType: "request", request: "spin" })
     * See Engage API documentation for full scope of requests and events
     */
    postMessage: function(data) {
        console.log('GameCommunicator sent the following message:', data)
        this.source.postMessage(data, this.targetOrigin)
    },
    /**
     * Receives the messages the PNG game dispatches
     * @@param {object} e
     */
    processGameMessage: function(e) {
        console.log('GameCommunicator reveiced: ', e.data)

        switch (e.data.type) {
            case 'backToLobby':
                if (!this.multiScreenMode) {
                    this.onGameExit()
                }
                break
            default:
                break
        }
    },
}
